// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC7E-hMo2Qzr8mwXIGvrR2WbZQ9V-ZrEgs",
  authDomain: "heshe-4d6d1.firebaseapp.com",
  databaseURL: "https://heshe-4d6d1-default-rtdb.firebaseio.com",
  projectId: "heshe-4d6d1",
  storageBucket: "heshe-4d6d1.firebasestorage.app",
  messagingSenderId: "304570146000",
  appId: "1:304570146000:web:a05cccd574ad886da892d5",
  measurementId: "G-65W5WTFGXD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);

